import React from 'react';
import EditorDelete from '@wix/da-ds/pkg/Icons/24x24/EditorDelete';
import cn from 'classnames';
import EditorIconButton from '../../../../components/menus/_partials/EditorIconButton';
import s from '../../../../components/menus/buttons/buttons.scss';
const Delete = ({ editor })=>{
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        icon: EditorDelete,
        onClick: ()=>editor.chain().focus().daDeviationThumbDelete().run(),
        className: cn(s['button']),
        tooltipHoverDelay: 2000,
        tooltipText: "Remove Deviation"
    });
};
Delete.displayName = 'Delete';
export default Delete;

//# sourceMappingURL=Delete.js.map